import React, { useEffect, useState, useRef } from 'react';

const GOOGLE_API_KEY = 'AIzaSyBJmofDDcTvTdaLbK-YN4qCx_hhTyIWBeI';

const AddressPage = () => {
  const [addresses, setAddresses] = useState([]);
  const [form, setForm] = useState({
    street: '',
    city: '',
    state: '',
    zipcode: '',
    country: '',
  });
  const [loading, setLoading] = useState(true);
  const [defaultId, setDefaultId] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const streetInputRef = useRef();

  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.id;

  useEffect(() => {
    if (!userId) return;
  fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/address?user_id=${userId}`)
      .then(res => res.json())
      .then(data => {
        setAddresses(data.addresses || []);
        setDefaultId(data.defaultId || null);
        setLoading(false);
      });
  }, [userId]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (e.target.name === 'street') {
      fetchSuggestions(e.target.value);
    }
  };

  const handleDefaultChange = e => {
    setIsDefault(e.target.checked);
  };

  const fetchSuggestions = async (input) => {
    if (!input || input.length < 3) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${encodeURIComponent(input)}&types=address&key=${GOOGLE_API_KEY}`
    );
    const data = await res.json();
    if (data.status === 'OK') {
      setSuggestions(data.predictions);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = async (suggestion) => {
    setShowSuggestions(false);
    setSuggestions([]);
    // Get place details
    const placeId = suggestion.place_id;
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&key=${GOOGLE_API_KEY}`
    );
    const data = await res.json();
    if (data.status === 'OK') {
      const addr = data.result.address_components;
      setForm({
        street: [
          addr.find(a => a.types.includes('street_number'))?.long_name || '',
          addr.find(a => a.types.includes('route'))?.long_name || ''
        ].filter(Boolean).join(' '),
        city: addr.find(a => a.types.includes('locality'))?.long_name || '',
        state: addr.find(a => a.types.includes('administrative_area_level_1'))?.short_name || '',
        zipcode: addr.find(a => a.types.includes('postal_code'))?.long_name || '',
        country: addr.find(a => a.types.includes('country'))?.long_name || '',
      });
      // Focus next field
      if (streetInputRef.current) streetInputRef.current.blur();
    }
  };

  const verifyAddress = async address => {
    const query = encodeURIComponent(
      `${address.street}, ${address.city}, ${address.state}, ${address.zipcode}, ${address.country}`
    );
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${query}&key=${GOOGLE_API_KEY}`
    );
    const data = await res.json();
    return data.status === 'OK' ? data.results[0].formatted_address : null;
  };

  const handleAddAddress = async e => {
    e.preventDefault();
    if (!userId) return;

    const verified = await verifyAddress(form);
    if (!verified) {
      alert('Address could not be verified. Please check your input.');
      return;
    }

  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/address`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...form, user_id: userId, is_default: isDefault }),
    });
    if (res.ok) {
      setForm({ street: '', city: '', state: '', zipcode: '', country: '' });
      setIsDefault(false);
      // Refresh addresses
      const data = await res.json();
      setAddresses(data.addresses);
      setDefaultId(data.defaultId);
    }
  };

  const handleSetDefault = async id => {
    if (!userId) return;
  await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/address/default`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, address_id: id }),
    });
    setDefaultId(id);
  };

  if (loading) return <div style={styles.container}>Loading addresses...</div>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>My Addresses</h2>
      <div style={styles.list}>
        {addresses.length === 0 && <div>No addresses found.</div>}
        {addresses.map(addr => (
          <div key={addr.id} style={styles.card}>
            <div>
              <strong>{addr.street}</strong><br />
              {addr.city}, {addr.state} {addr.zipcode}<br />
              {addr.country}
            </div>
            <button
              style={{
                ...styles.defaultBtn,
                background: addr.id === defaultId ? '#388e3c' : '#4078c0',
              }}
              onClick={() => handleSetDefault(addr.id)}
              disabled={addr.id === defaultId}
            >
              {addr.id === defaultId ? 'Default' : 'Set as Default'}
            </button>
          </div>
        ))}
      </div>
      <form style={styles.form} onSubmit={handleAddAddress}>
        <h3 style={{ marginBottom: '12px', color: '#4078c0' }}>Add New Address</h3>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            name="street"
            placeholder="Street"
            value={form.street}
            onChange={handleChange}
            style={styles.input}
            required
            autoComplete="off"
            ref={streetInputRef}
            onFocus={() => form.street.length > 2 && setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
          />
          {showSuggestions && suggestions.length > 0 && (
            <ul style={styles.suggestions}>
              {suggestions.map(s => (
                <li
                  key={s.place_id}
                  style={styles.suggestionItem}
                  onMouseDown={() => handleSuggestionClick(s)}
                >
                  {s.description}
                </li>
              ))}
            </ul>
          )}
        </div>
        <input
          type="text"
          name="city"
          placeholder="City"
          value={form.city}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="state"
          placeholder="State"
          value={form.state}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="zipcode"
          placeholder="Zip Code"
          value={form.zipcode}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="country"
          placeholder="Country"
          value={form.country}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <label style={{ margin: '8px 0', fontSize: '1rem', color: '#4078c0' }}>
          <input
            type="checkbox"
            checked={isDefault}
            onChange={handleDefaultChange}
            style={{ marginRight: '8px' }}
          />
          Set as default address
        </label>
        <button type="submit" style={styles.button}>Add Address</button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    textAlign: 'center',
  },
  title: {
    marginBottom: '24px',
    color: '#4078c0',
    fontSize: '1.5rem',
  },
  list: {
    marginBottom: '32px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    padding: '18px',
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  defaultBtn: {
    padding: '8px 18px',
    borderRadius: '6px',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
  },
  form: {
    background: '#f5f6fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    padding: '24px',
    marginTop: '24px',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #dbe6f6',
    fontSize: '1rem',
  },
  button: {
    padding: '12px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
    marginTop: '8px',
  },
  suggestions: {
    position: 'absolute',
    top: '44px',
    left: 0,
    right: 0,
    background: '#fff',
    border: '1px solid #dbe6f6',
    borderRadius: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    zIndex: 10,
    listStyle: 'none',
    margin: 0,
    padding: 0,
    maxHeight: '180px',
    overflowY: 'auto',
  },
  suggestionItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee',
    fontSize: '1rem',
  },
};

export default AddressPage;